<template>
	<Modals
		v-if="display"
		:title="showTitleModal"
		:validateBeforeClose="validateBeforeClose"
		:display="display"
		@show="closeGlobalFormModal"
		:parentTag="'form'"
		:novalidate="'novalidate'"
		:fullMobile="true"
	>
		<template #modal-content="{handleScroll}">
			<div class="copy-form">
				<div class="results-toolbar results-toolbar--variant-one">
					<div class="results-toolbar__search">
						<Search :placeholder="placeholder" v-model="search" />
					</div>
					<div class="results-toolbar__counter">
						<ResultCounter
							:counter="resultCounter"
							v-if="hasResults"
						/>
					</div>
				</div>

				<CopyFormList
					:display="display"
					:source="pagingModel"
					@has-scroll="handleScroll"
					@page="updatePage"
					:actionType="actionType"
				/>
			</div>
		</template>
		<template #modal-footer>
			<Button
				className="btn--link"
				labelText="Cancel"
				:btnClick="closeGlobalFormModal"
			/>
		</template>
	</Modals>
</template>

<script>
import Modals from '@/components/shells/modal/modals';
import Search from '@/components/forms/search/search';
import Button from '@/components/forms/button/button';
import PaginationPage from '@/mixins/infiniteScroll/page';
import ResultCounter from '@/site-components/result-counter/result-counter';
import CopyFormList from '@/views/global-forms/copy-forms-list';
import { mapActions, mapState } from 'vuex';
import { getPrintType, getStatusDescription } from '@/utils/function';

export default {
	name: 'GlobalFormsCopyOfModal',
	mixins: [PaginationPage],
	components: {
		Modals,
		Search,
		Button,
		ResultCounter,
		CopyFormList
	},
	model: {
		prop: 'display',
		event: 'show'
	},
	props: {
		title: {
			type: String,
			default: ''
		},
		placeholder: {
			type: String,
			default: 'Search by form name, revision, or description'
		},
		parentTag: {
			type: String,
			default: 'div'
		},
		validateBeforeClose: {
			type: Boolean,
			default: false
		},
		display: {
			type: Boolean,
			default: false
		},
		actionType: {
			type: String,
			default: 'Copy'
		}
	},
	data() {
		return {
			search: ''
		};
	},
	computed: {
		...mapState('customerForms', ['customerId']),
		...mapState('forms',['forms']),
		showTitleModal() {
			return this.actionType + ' Form';
		}
	},
	methods: {
		...mapActions('forms', ['loadForms']),

		closeGlobalFormModal(e) {
			if (e) e.preventDefault();
			if (!this.validateBeforeClose) {
				if (this.search) this.search = '';
				this.$emit('show', false);
			}
		},
		async fetchData(page) {
			let parameters = {
				page: page || 1,
				count: 10,
				search: this.search,
				customerId: this.customerId
			};

			if (this.actionType == 'Assign') {
				Object.assign(parameters, { active: true, published: true });
			}

			await this.loadForms(parameters);
			this.parseResponse(this.forms);
		},
		parseResponse(response) {
			let data = { ...response };
			this.setPagingData(data, data.page === 1);
		},
		getformType(form) {
			return getPrintType(form.formPrintType);
		},
		moreFormInformation(form) {
			return (
				form.description +
				'/' +
				getStatusDescription(form.active) +
				'/' +
				getPrintType(form.formPrintType)
			);
		},
		updatePage(page) {
			this.fetchData(page);
		}
	},
	watch: {
		display: {
			handler(val) {
				if (val) {
					this.fetchData(1);
				}
			}
		},
		search: {
			handler() {
				if (this.display) {
					this.fetchData(1);
				}
			}
		}
	}
};
</script>

<style lang="scss" scoped>
::v-deep .results-toolbar .results-toolbar__search {
	@include mq($from: md) {
		width: 350px;
	}
}

::v-deep .modal__body {
	overflow: initial;
}

.copy-form {
	@include mq($from: md) {
		width: 660px;
	}
}
</style>
